module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/home"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('b', [_vm._v("东迅")])]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_vm._v("东迅工资条")])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('el-dropdown', {
    staticClass: "header-dropdown-devin",
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": this.memoList.filter(function (m) { return !m.handled; }).length,
      "hidden": this.memoList.length <= 0
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "ti-bell"
  })])], 1)], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown",
      "size": "medium"
    },
    slot: "dropdown"
  }, [_c('ul', {
    staticClass: "dropdown-menu-devin"
  }, [_c('li', [_c('ul', {
    staticClass: "menu"
  }, [_vm._l((_vm.memoList), function(item) {
    return [_c('li', [_c('i', {
      staticStyle: {
        "margin": "10px 20px 0 0"
      },
      on: {
        "click": function($event) {
          return _vm.handleMemoHandledClick(item.id)
        }
      }
    }, [_c('el-switch', {
      attrs: {
        "active-color": "#ff4949",
        "inactive-color": "#13ce66"
      },
      on: {
        "change": _vm.handleMemoHandledChange
      },
      model: {
        value: (item.handled),
        callback: function($$v) {
          _vm.$set(item, "handled", $$v)
        },
        expression: "item.handled"
      }
    })], 1), _vm._v(" "), _c('a', [_c('h3', {
      class: {
        handled: item.handled
      }
    }, [(item.followId) ? _c('a', {
      staticStyle: {
        "text-decoration": "underline !important",
        "color": "blue !important",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.handleFollowClick(item.customerId, item.followId)
        }
      }
    }, [_vm._v(_vm._s(item.remark))]) : _c('a', [_vm._v(_vm._s(item.remark))]), _vm._v(" "), _c('span', {
      staticClass: "text-yellow fontello-record"
    })]), _vm._v(" "), _c('p', {
      class: {
        handled: item.handled
      }
    }, [_vm._v(_vm._s(item.memoAtText))])])])]
  })], 2)])])])], 1)], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31411198!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = 450
// module chunks = 2